import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['select', 'amountInput', 'error', 'errorLink', 'cta', 'envelopeError'];
  static values = { hasEnvelope: Boolean, remainingEnvelope: Number };

  connect() {
    this.update();
  }

  update() {
    const option = this.selectTarget.selectedOptions[0];
    const amount = parseFloat(this.amountInputTarget.value) || 0;

    const kycBlocked = this.#toggleKyc(option);
    const envelopeBlocked = this.#toggleEnvelope(amount);

    this.ctaTarget.disabled = kycBlocked || envelopeBlocked;

    this.dispatch('change', {
      detail: {
        selected: Boolean(option?.value),
        blocked: option?.dataset.blocked === 'true',
        name: option?.dataset.name || '',
        balance: parseFloat(option?.dataset.balance) || 0,
        beneficiary: option?.dataset.beneficiary || '',
        iban: option?.dataset.virtualIban || '',
        bic: option?.dataset.virtualBic || '',
        amount,
      },
    });
  }

  #toggleKyc(option) {
    const blocked = option?.dataset.blocked === 'true';

    if (blocked) {
      this.errorLinkTarget.href = option.dataset.profilePath;
      this.errorTarget.classList.remove('d-none');
    } else {
      this.errorTarget.classList.add('d-none');
    }

    return blocked;
  }

  #toggleEnvelope(amount) {
    if (!this.hasEnvelopeValue) return false;
    if (this.remainingEnvelopeValue <= 0) return true;

    const exceeded = amount > this.remainingEnvelopeValue;

    if (this.hasEnvelopeErrorTarget) {
      this.envelopeErrorTarget.classList.toggle('d-none', !exceeded);
    }

    return exceeded;
  }
}
